// extracted by mini-css-extract-plugin
module.exports = {"match":"src-screens-Appointments-pickers-ServicePicker-ServicePicker-module__match--DaQIp"};